<div class="content" *ngIf="policy$ | async as policy">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2>Attendance Policy Details : {{ policy.title }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="eps.attendance.policiesPath" class="breadcrumb-button">
              Attendance Policy</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Attendance Policy Details</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="mb-2">
        <button (click)="openBusiness(assignPolicyModal)" class="btn btn-primary d-flex align-items-center">
          <i class="ti ti-circle-plus me-2"></i>Assign Policy
        </button>
      </div>
    </div>
  </div>
  <!-- Breadcrumb -->

  <!-- Main Card -->
  <div class="row">
    <div class="card">
      <div class="card-body">
        <!-- Header -->
        <div class="pb-3 d-flex align-items-center justify-content-between">
          <!-- Left: Title -->
          <h3 class="mb-0">Manage Assignments</h3>

          <!-- Right: Search -->
          <div style="width: 250px">
            <input type="text" [(ngModel)]="search" (input)="onSearchEmployee()" placeholder="Search employee..."
              class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="custom-datatable-filter table-responsive">
            <ng-container *ngIf="assignedEmployees.length > 0; else noRecords">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let assignment of assignedEmployees">
                    <ng-container *ngIf="assignment.user">
                      <!-- Name -->
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="ms-2">
                            <p class="text-dark mb-0">
                              <a [routerLink]="[eps.hrm.employeePath, assignment.user?.id]">
                                {{ assignment.user?.firstName | capitalize }}
                                {{ assignment.user?.lastName | capitalize }}
                              </a>
                            </p>
                          </div>
                        </div>
                      </td>

                      <!-- Start Date -->
                      <td>
                        <span *ngIf="idForEdit !== assignment.id">
                          {{ assignment.startDate | date: 'MMM d, yyyy h:mm a' }}
                        </span>

                        <div *ngIf="idForEdit === assignment.id"
                          style="display: flex; align-items: center; gap: 8px; max-width: 320px">
                          <input type="datetime-local" [(ngModel)]="assignment.startDate" class="form-control" />

                          <button class="btn btn-success btn-sm" (click)="saveStartDate(assignment)">
                            <i class="ti ti-check"></i>
                          </button>

                          <button class="btn btn-danger btn-sm" (click)="cancelEdit()">x</button>
                        </div>
                      </td>
                      <!-- End Date  -->

                      <td>
                        <span *ngIf="idForEdit !== assignment.id">
                          {{ assignment.endDate | date: 'MMM d, yyyy h:mm a' }}
                        </span>

                        <div *ngIf="idForEdit === assignment.id"
                          style="display: flex; align-items: center; gap: 8px; max-width: 320px">
                          <input type="datetime-local" [(ngModel)]="assignment.endDate" class="form-control" />

                          <button class="btn btn-success btn-sm" (click)="saveEndDate(assignment)">
                            <i class="ti ti-check"></i>
                          </button>

                          <button class="btn btn-danger btn-sm" (click)="cancelEdit()">
                            x
                          </button>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="text-end">
                        <div class="action-icon d-inline-flex">
                          <button type="button" class="btn btn-icon-style p-1 m-1" *ngIf="idForEdit !== assignment.id"
                            (click)="editStartDate(assignment)" title="Edit">
                            <i class="ti ti-edit"></i>
                          </button>
                          <button type="button" class="btn btn-icon-style p-1 m-1" *ngIf="idForEdit !== assignment.id"
                            (click)="deleteAssignment(assignment.id)" title="Edit"></button>
                          <button type="button" class="btn btn-icon-style p-1 m-1"
                            (click)="openDelete(deleteModal, assignment.id)" aria-label="Delete item"
                            data-bs-toggle="tooltip" title="Delete">
                            <i class="ti ti-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
              <!-- This Is For Pagination -->
              <div class="d-flex align-items-center justify-content-between ms-2" *ngIf="totalCount > 0">
                <div>
                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                  {{ totalCount }} entries
                </div>

                <div class="has-text-centered mt-3">
                  <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
                    (pageChange)="onPageChange($event)">
                  </app-pagination>
                </div>
              </div>
            </ng-container>

            <!-- No records -->
            <ng-template #noRecords>
              <div class="text-center">Record not available</div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #assignPolicyModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Attendance Policy</h4>
    <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignAttendancePolicyform" (ngSubmit)="onAssign()">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="employeeIds" class="col-form-label">Employees <span class="text-danger">*</span></label>
              <ng-select class="me-3 w-100" multiple [items]="employeeList" bindValue="id" placeholder="Select Employee"
                [searchable]="true" [clearable]="true" [searchFn]="customSearchFnEmployee" style="width: 200px"
                (change)="onEmployeeSelect($event)" formControlName="employeeIds">
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="
                  assignAttendancePolicyform.get('employeeIds')?.invalid &&
                  assignAttendancePolicyform.get('employeeIds')?.touched
                ">
                <span class="text-danger">{{ getErrorMessage('employeeIds') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label class="col-form-label">
                Assignment Date <span class="text-danger">*</span>
              </label>
              <input type="date" class="form-control" formControlName="assignmentDate"
                (change)="onAssignmentDateChange($event)" />

              <div *ngIf="
                  assignAttendancePolicyform.get('assignmentDate')?.invalid &&
                  assignAttendancePolicyform.get('assignmentDate')?.touched
                ">
                <span class="text-danger">{{ getErrorMessage('assignmentDate') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- this is for end Date  -->

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label class="col-form-label">
                End Date <span class="text-danger">*</span>
              </label>

              <input type="date" class="form-control" formControlName="endDate" (change)="onEndDateChange($event)" />

              <div *ngIf="
          assignAttendancePolicyform.get('endDate')?.invalid &&
          assignAttendancePolicyform.get('endDate')?.touched
        ">
                <span class="text-danger">
                  {{ getErrorMessage('endDate') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- .CODE ENDED -->
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="!assignAttendancePolicyform.valid">
        <ng-container *ngIf="isLoading; else loading">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Assign...
        </ng-container>
        <ng-template #loading> Assign </ng-template>
      </button>
    </div>
  </form>
</ng-template>

<ng-template #deleteModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">
      You want to delete the attendance policy, this can't be undone once you delete.
    </p>
    <div class="d-flex justify-content-center">
      <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal" (click)="onClose()">Cancel</a>
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</ng-template>